const productRanges = [
  {
    title: 'Infrared Beds',
    description: 'Our infrared beds boast advanced technology designed for both commercial and residential use, enhancing wellness through therapeutic heat and light.',
  },
  {
    title: 'Redlight Masks',
    description: 'These innovative masks are equipped with advanced redlight technology to target skin rejuvenation and overall facial health.',
  },
  {
    title: 'Redlight Panels',
    description: 'Perfect for personal or professional use, our panels deliver effective red and infrared light therapy in a compact form.',
  },
  {
    title: 'Commercial Solutions',
    description: 'We offer white labeling for commercial units, allowing businesses to provide tailored products while maintaining brand integrity.',
  },
  {
    title: 'Color Therapy',
    description: 'Our color therapy systems complement our product lines, providing holistic healing solutions through vibrant light wavelengths.',
  },
];

const images = [
  'https://public.readdy.ai/ai/img_res/2a6078dd02097a8e8dbec6758cfde995.jpg',
  'https://readdy.ai/api/search-image?query=red%20light%20therapy%20panel%20mounted%20on%20wall%20emitting%20bright%20red%20LED%20wavelengths%20in%20modern%20wellness%20center%2C%20professional%20grade%20equipment%2C%20clean%20white%20background%2C%20therapeutic%20infrared%20technology%2C%20medical%20spa%20setting%2C%20high-tech%20health%20device&width=800&height=600&seq=prod-range-panel-002&orientation=landscape',
];

const ProductRangeSection = () => {
  return (
    <section id="product-range" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Content */}
          <div>
            <h2 className="font-serif text-4xl md:text-5xl font-light text-white mb-12">
              Product Range
            </h2>

            <div className="space-y-8">
              {productRanges.map((range, index) => (
                <div key={index}>
                  <h3 className="font-serif text-xl font-medium text-white mb-2">{range.title}</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">{range.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="grid grid-cols-1 gap-6">
            {images.map((image, index) => (
              <div key={index} className="relative h-64 rounded-lg overflow-hidden">
                <img 
                  src={image}
                  alt={`Product ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductRangeSection;
